export async function clickLink(url: string): Promise<void> {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('target', '_blank');
  link.click();
  link.remove();
}
